module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/images/Stills_1_dramas-dedba30f8cb0d29b3d058fa12ac38d4f.jpg";